import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Button,
  SimpleGrid,
  Image,
  Center,
  LinkBox,
  LinkOverlay,
  Select,
} from '@chakra-ui/react'

import { FiBox } from 'react-icons/fi'
import { BiRectangle } from 'react-icons/bi'

import { skyBoxes } from '../../_mocks_/skybox'

import { setUpEnvironment } from '../utils/environment'
import { changeSkybox, toggleSkyBox } from '../utils/design/customization'

import { Context3D } from '../utils/3d-context'
import { useEffect, useState } from 'react'
import { IMockSkyBox, IMockSkyBoxType } from '../type/skyboxType'

export const SkyBox = () => {
  const context = Context3D.get()
  const [skyBoxEnabled, setSkyBoxEnabled] = useState<boolean>(true)

  const checkEnabled = () => {
    const backgroundHdrSkybox = context.scene?.getMeshByName('hdrSkyBox')
    const bgImage = context?.scene?.layers?.find(
      r => r.name === 'BackgroudImage'
    )

    if (backgroundHdrSkybox?.isEnabled() || (bgImage && bgImage.scale?.x > 0)) {
      setSkyBoxEnabled(true)
    } else {
      setSkyBoxEnabled(false)
    }
  }

  useEffect(() => {
    checkEnabled()
  })

  return (
    <>
      <Button
        size="sm"
        onClick={() => {
          toggleSkyBox()
          checkEnabled()
        }}
      >
        Toggle Skybox
      </Button>

      {skyBoxEnabled && (
        <>
          <Accordion defaultIndex={[]} allowMultiple>
            <AccordionItem border="0">
              <AccordionButton padding="0">
                <Button flex="1" size="sm">
                  SkyBox
                </Button>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                <SimpleGrid columns={2} spacing={5}>
                  {skyBoxes.map((box: IMockSkyBox) => (
                    <LinkBox as="article" cursor="pointer">
                      <Center>
                        <LinkOverlay
                          onClick={() => {
                            setUpEnvironment(box)
                          }}
                        >
                          <Image
                            src={box.previewUrl}
                            borderRadius="full"
                            boxSize="50px"
                            alt="test"
                            align="center"
                          ></Image>
                        </LinkOverlay>
                      </Center>
                      <Center>
                        {box.type === IMockSkyBoxType.BOX2D ? (
                          <BiRectangle />
                        ) : (
                          <FiBox />
                        )}
                      </Center>
                    </LinkBox>
                  ))}
                </SimpleGrid>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>

          <Select
            placeholder="Select skybox option"
            size="sm"
            onChange={e => changeSkybox(e.target.value + '.hdr')}
          >
            <option value="cayley_interior_1k">cayley interior</option>
            <option value="christmas_photo_studio_04_1k">
              christmas_photo_studio
            </option>
            <option value="comfy_cafe_1k">comfy_cafe</option>
            <option value="hamburg_hbf_1k">hamburg_hbf</option>
            <option value="modern_buildings_1k">modern_buildings</option>
            <option value="palermo_sidewalk_1k">palermo_sidewalk</option>
            <option value="photo_studio_01_1k">photo_studio</option>
            <option value="parking">parking</option>
            <option value="spiaggia_di_mondello_1k">
              spiaggia_di_mondello
            </option>
            <option value="studio_small_04_1k">studio_small</option>
            <option value="wide_street_01_1k">wide_street</option>
          </Select>
        </>
      )}
    </>
  )
}
